import { useInvitations } from '@/hooks/use-invitations';
import { InvitationsTable } from '@/components/invitations/invitations-table';
import { CreateInvitationDialog } from '@/components/invitations/create-invitation-dialog';
import { Skeleton } from '@/components/ui/skeleton';

export default function InvitationsPage() {
  const { data, isLoading } = useInvitations();

  return (
    <div className="space-y-4">
      <div className="flex justify-end">
        <CreateInvitationDialog />
      </div>

      {isLoading ? (
        <div className="space-y-2">
          {Array.from({ length: 3 }).map((_, i) => (
            <Skeleton key={i} className="h-12 w-full" />
          ))}
        </div>
      ) : (
        <InvitationsTable invitations={data ?? []} />
      )}
    </div>
  );
}
